import DialogFooter from './DialogFooter';

export default DialogFooter;
